// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flag-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 14H11L13 16H20L18 10.5H13L11 8.5H4V14Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M13 10.5H18L20 5H13L11 3H4V8.5H11L13 10.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 3H11L13 5H20L18 10.5M4 3V14M4 3V8.5H11L13 10.5H18M4 14H11L13 16H20L18 10.5M4 14V21.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flag-1')
export default class Flag1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flag-1',
    }
  }
}
